import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'CUSTOM LOAD EDIT',
      title: 'CUSTOM LOAD EDIT',
      executeAction: 'Submit',
      errorMessage: 'Error',
      successMessage: 'All %{count} rows added',
      addedItemsCount: 'Added rows count',
      errorItems: 'Errors',
      fields: {},
    },
  },
};
